import AdminConfigDevicesEdit from "./AdminConfigDevicesEdit";
export default AdminConfigDevicesEdit;
